export default {
  public: 'earth',
  unlisted: 'moon',
  private: 'lock',
  direct: 'message',
  local: 'building',
};
